export default __webpack_public_path__ + "static/media/resume.96425f6f.svg";